
























































import { Component } from 'vue-property-decorator';
import DclAdd from '@/components/DraggableCardList/DclAdd.vue';
import DclCard from '@/components/DraggableCardList/DclCard.vue';
import DclGrid from '@/components/DraggableCardList/DclGrid.vue';
import ContactNumbersSection from './ContactNumbersSection';

@Component({
	components: {
		DclAdd,
		DclCard,
		DclGrid,
	}
})
export default class ContactNumbers extends ContactNumbersSection {
	// @Action
}

